import * as React from 'react';
import I18N from 'src/services/I18NService';

const HomePage = () => {
  return <div>{I18N.get('common_partner_welcome')}</div>;
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/views/Home.tsx